import React, { Component } from "react";
import Pagination from "react-js-pagination";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import { toJS } from "mobx";

export default
@inject("commonStore")
@withRouter
@observer
class PageNation extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    if (isNaN(this.props.commonStore.activePage)) {
      //페이지를 처음 방문할 때 현재 페이지 1로 설정
      localStorage.setItem("currentPage", 1);
      this.props.commonStore.setActivePage(1);
    }

    this.props.commonStore.setMode(parseInt(localStorage.getItem("menu") === null ? 0 : localStorage.getItem("menu"))); //새로고침하거나 새 페이지 열 때 mode값 유지하기

    if (this.props.commonStore.mode === 0) {
      this.props.commonStore.getAllPage(localStorage.getItem("currentPage")).then((v) => {
        this.props.commonStore.setPage(v);
      });
    }
    if (this.props.commonStore.mode === 1) {
      this.props.commonStore.getPage("기사", localStorage.getItem("currentPage")).then((v) => {
        this.props.commonStore.setPage(v);
      });
    }
    if (this.props.commonStore.mode === 2) {
      this.props.commonStore.getPage("칼럼", localStorage.getItem("currentPage")).then((v) => {
        this.props.commonStore.setPage(v);
      });
    }
    if (this.props.commonStore.mode === 3) {
      //내 페이지
      this.props.commonStore.getMyPage(localStorage.getItem("currentPage")).then((v) => {
        this.props.commonStore.setPage(v);
      });
    }
  }

  handlePageChange(pageNumber) {
    if (this.props.commonStore.mode === 0) {
      this.props.commonStore.getAllPage(pageNumber).then((v) => {
        this.props.commonStore.setPage(v);
      });
    }
    if (this.props.commonStore.mode === 1) {
      this.props.commonStore.getPage("기사", pageNumber).then((v) => {
        this.props.commonStore.setPage(v);
      });
    }
    if (this.props.commonStore.mode === 2) {
      this.props.commonStore.getPage("칼럼", pageNumber).then((v) => {
        this.props.commonStore.setPage(v);
      });
    }
    if (this.props.commonStore.mode === 3) {
      this.props.commonStore.getMyPage(pageNumber).then((v) => {
        this.props.commonStore.setPage(v);
      });
    }
    if (this.props.commonStore.mode === 4) {
      if (this.props.commonStore.filterList.word.length === 0) {
        //검색안하고 그냥 치면?
        this.props.commonStore.getAllList().then((res) => {
          if (this.props.commonStore.filterList.status === 0) {
            this.props.commonStore.setPage(res.filter((v) => v.state).slice(parseInt(`${pageNumber - 1}0`), parseInt(`${pageNumber}0`))); //진행도 필터링
          } else {
            this.props.commonStore.setPage(
              res.filter((v) => v.state === this.props.commonStore.filterList.status).slice(parseInt(`${pageNumber - 1}0`), parseInt(`${pageNumber}0`))
            ); //진행도 필터링
          }
        });
      } else {
        if (this.props.commonStore.filterList.titleWriter === "제목") {
          this.props.commonStore.getAllList().then((res) => {
            if (this.props.commonStore.filterList.status == 0) {
              this.props.commonStore.setPage(
                res
                  .filter((v) => v.title.includes(this.props.commonStore.filterList.word) && v.state)
                  .slice(parseInt(`${pageNumber - 1}0`), parseInt(`${pageNumber}0`))
              ); //진행도 필터링
            } else {
              this.props.commonStore.setPage(
                res
                  .filter((v) => v.title.includes(this.props.commonStore.filterList.word) && v.state === this.props.commonStore.filterList.status)
                  .slice(parseInt(`${pageNumber - 1}0`), parseInt(`${pageNumber}0`))
              ); //진행도 필터링
            }
          }); // 페이지네이션 전체 길이를 구하기 위해 따로 구한다.
        } else if (this.props.commonStore.filterList.titleWriter === "작성자") {
          this.props.commonStore.getAllList().then((res) => {
            if (this.props.commonStore.filterList.status === 0) {
              this.props.commonStore.setPage(
                res
                  .filter((v) => v.writer.includes(this.props.commonStore.filterList.word) && v.state)
                  .slice(parseInt(`${pageNumber - 1}0`), parseInt(`${pageNumber}0`))
              ); //진행도 필터링
            } else {
              this.props.commonStore.setPage(
                res
                  .filter((v) => v.writer.includes(this.props.commonStore.filterList.word) && v.state === this.props.commonStore.filterList.status)
                  .slice(parseInt(`${pageNumber - 1}0`), parseInt(`${pageNumber}0`))
              ); //진행도 필터링
            }
          }); // 페이지네이션 전체 길이를 구하기 위해 따로 구한다.
        }
      }
    }
    this.props.commonStore.setActivePage(pageNumber);
    localStorage.setItem("currentPage", pageNumber);
  }
  render() {
    return (
      <Box>
        <Pagination
          hideDisabled
          itemClassFirst="first"
          itemClassPrev="prev"
          itemClassNext="next"
          itemClassLast="last"
          prevPageText="‹"
          firstPageText="«"
          lastPageText="»"
          nextPageText="›"
          itemClass="page-item"
          linkClass="page-link"
          activePage={this.props.commonStore.activePage}
          itemsCountPerPage={1}
          totalItemsCount={
            this.props.commonStore.mode === 0
              ? Math.ceil(this.props.lengths[0] / 10) // 전체
              : this.props.commonStore.mode === 1
              ? Math.ceil(this.props.lengths[1] / 10) // 기사
              : this.props.commonStore.mode === 2
              ? Math.ceil(this.props.lengths[2] / 10) // 칼럼
              : this.props.commonStore.mode === 3
              ? Math.ceil(this.props.lengths[3] / 10) // 내가 쓴 글
              : Math.ceil(this.props.commonStore.filterLength / 10) // 검색 필터링
          }
          pageRangeDisplayed={5}
          onChange={this.handlePageChange.bind(this)}
        />
      </Box>
    );
  }
}

const Box = styled.div`
  width: 100%;
  height: 10%;
  display: flex;
  justify-content: center;
  align-items: center;

  & > .pagination {
    display: flex;

    > .first,
    > .prev,
    > .next,
    > .last {
      width: 30px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #e3e3e3;
      box-sizing: border-box;
      border-radius: 4px;
      color: #808495 !important;
      font: 26px "Gothic A1", sans-serif;
      margin: 0 2.5px;
    }

    > .prev {
      margin-right: 10px;
    }

    > .next {
      margin-left: 10px;
    }

    > .page-item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 30px;
      color: #b0afc7;
    }

    > .active {
      font-weight: bold;
      color: black;
    }
  }
`;
